import React, { useEffect, useState } from "react";

export default function PopupBanner() {
	const [showPopup, setShowPopup] = useState(false);

	useEffect(() => {
		const now = new Date();

		// Banner will stop showing starting June 28, 2026
		const bannerEndDate = new Date(2026, 8, 31);
		// month is 0-based: 5 = June

		if (now >= bannerEndDate) {
			setShowPopup(false);
			return;
		}

		const isClosed = getCookie("popupBannerClosed");

		if (!isClosed) {
			setShowPopup(true);
		}
	}, []);

	const handleClose = () => {
		const expires = getNextMidnight();

		document.cookie = `popupBannerClosed=true; expires=${expires.toUTCString()}; path=/`;

		setShowPopup(false);
	};

	if (!showPopup) return null;

	return (
		<div className="fgh-popup-banner">
			<img
				src="/images/banners/CASH_AND_CARD-DOUBLE-REWARDS-POPUP.webp"
				alt="Rise of Heroes Flame of Victory Banner"
			/>

			<button type="button" onClick={handleClose}>
				CLOSE
			</button>
		</div>
	);
}

function getCookie(name) {
	const cookies = document.cookie.split("; ");

	const cookie = cookies.find((item) => item.startsWith(`${name}=`));

	return cookie ? cookie.split("=")[1] : null;
}

function getNextMidnight() {
	const tomorrow = new Date();

	tomorrow.setDate(tomorrow.getDate() + 1);
	tomorrow.setHours(0, 0, 0, 0);

	return tomorrow;
}
